// "Find in model and sheets" from the glance (owner, 2026-09-19): a NEW tab, and a target the search can
// resolve, not free text alone ("SERENITY 368" also found SERENITY ROOM 135 on another level).
// Contract with root-f5 (leader-approved): the link names the room or item; the search asks
// GET /projects/:id/glance/locate?room=|item= for its level, polygon, model id and the sheets it was read
// from (with its box on each registered page). q is kept for the search box's text.
//   /split-search?projectId=P&glance=room:<roomId>|item:<level:system:x,y>&q=<text>&from=glance
const round2 = (n) => Math.round(n * 100) / 100;

function link(projectId, target, q) {
  const p = new URLSearchParams();
  p.set("projectId", projectId);
  p.set("glance", target);
  if (q) p.set("q", q);
  p.set("from", "glance");
  return `/split-search?${p.toString()}`;
}

export function roomSearchUrl(projectId, room) {
  if (!room || !room.id) return "";
  return link(projectId, `room:${room.id}`, [room.name, room.number].filter(Boolean).join(" "));
}

// The same key as the server's utils/glance/locate itemKey.
export const itemKey = (it) => `${it.L}:${it.s}:${round2(it.x)},${round2(it.y)}`;

export function itemSearchUrl(projectId, item) {
  if (!item || item.x == null || item.y == null) return "";
  return link(projectId, `item:${itemKey(item)}`, item.tag || item.t || "");
}
